export class FacePressuresModelInterval {

    constructor(calculation, data = {}) {

        this.id = data.id ?? null;
        this.uid = data.uid ?? null;
        this.calculation = calculation ?? null;
        this.modelInterval = data.modelInterval ?? null;
        this.modelSection = data.modelSection ?? null;
        this.soilUnitWeightGamaCalcMethod = data.soilUnitWeightGamaCalcMethod ?? null;
        this.soilUnitWeightGama = data.soilUnitWeightGama ?? null;

    }

    get isWithinWaterBody() {
        return this.modelInterval?.isWithinWaterBody ?? null;
    }

    get waterBody() {
        return this.modelInterval?.waterBody ?? null;
    }

    get waterBodyType() {
        return this.waterBody?.waterBodyType ?? null;
    }

    get waterUnitWeightGamaW() {
        return this.waterBody?.waterUnitWeightGamaW ?? null;
    }

    get geoType() {
        return this.modelInterval?.geoType ?? null;
    }

    get bulkUnitWeightGama() {
        return this.geoType?.bulkUnitWeightGama ?? null;
    }

    get dryUnitWeightGamaD() {
        return this.geoType?.dryUnitWeightGamaD ?? null;
    }

    get saturatedUnitWeightGamaSat() {
        return this.geoType?.saturatedUnitWeightGamaSat ?? null;
    }

    get degreeOfSaturationSr() {
        return this.geoType?.degreeOfSaturationSr ?? null;
    }

    get moistureContentW() {
        return this.geoType?.moistureContentW ?? null;
    }

}
